// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Benefits_wrapper__D5J7V"};